var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLLeader({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    fill: "#FEFAF5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 39.5,
    stroke: "#F7B27A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3118 62V18.3636H35.2166V55.3736H54.4354V62H27.3118Z",
    fill: "#EF6820"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLLeader);
export default __webpack_public_path__ + "static/media/l-leader.4b5a549a90f52a11ecf94410854a0871.svg";
export { ForwardRef as ReactComponent };